import { InjectionToken } from "@angular/core";

export const CULTURE_CODE = new InjectionToken("CULTURE_CODE");

export const COUNTRY_CODE = new InjectionToken("COUNTRY_CODE");
